import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/theme.scss';
import './styles/tokens.css';
import './styles/app.css';
import './i18n';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
